<template>
    <div class="mobile-table">
        <div
        v-for="(item, index) in items"
        :key="`lineGroupLine${index}`"
        class="mobile-fake-row">
            <div class="item-info-row">
                <div class="label">{{ t('payments.requests.baiPaga.detailModal.article') }}</div>
                <div class="value">{{ item.description }}</div>
            </div>
            <div class="item-info-row">
                <div class="label">{{ t('payments.requests.baiPaga.detailModal.unitCost') }}</div>
                <div class="value">{{ amountFormat(item.amountPerItem, currency) }}</div>
            </div>
            <div class="item-info-row">
                <div class="label">{{ t('payments.requests.baiPaga.detailModal.quantity') }}</div>
                <div class="value">{{ item.count }}</div>
            </div>
            <div class="item-info-row">
                <div class="label">{{ t('payments.requests.baiPaga.detailModal.discount') }}</div>
                <div class="value">{{ item.discount }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
/* Assets */
import { amountFormat } from '@/assets/scripts/amounts'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** Props received:
@items { Array }
@currency { String }
*/
const props = defineProps({
    items: Array,
	currency: String
})

</script>

<style lang="scss" scoped>
.mobile-table {
    width: 100%;
    height: auto;

    display: flex;
    flex-direction: column;
    gap: 12px;

    .mobile-fake-row {
        display: flex;
        flex-direction: column;
        gap: 8px;

        padding-bottom: 12px;
        border-bottom: 1px solid rgba(0,50,90,.08);

        &:last-of-type {
            border: none;
        }

        .item-info-row {
            display: flex;
            align-items: center;
            gap: 12px;

            .label {
                width: 102px;

                @include H7-Medium;
                color: var(--secondary-dark-1);
            }

            .value {
                @include H5-Medium;
                line-height: 21px;
                color: var(--secondary-dark-2);
                text-overflow: ellipsis;

                overflow: hidden;
            }
        }
    }
}
</style>
